/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 0；可申请
// 1；审核中（用户有一个申请）
// 2；审核通过 （用户已成为主播）
// 3；用户已拒绝
// 4；邀请已过期
export enum InviteStatus {
  Apply = 0,
  Check = 1,
  Pass = 2,
  NoPass = 3,
  Reject = 4,
  Fail = 5,
}

// 审核状态  http://wiki.xunlei.cn/pages/viewpage.action?pageId=113921430
export const getTablentApplyInfo = createAsyncThunk(
  'TalentApply/getTablentApplyInfo',
  async (p, store: any) => {
    const resp = await http.post('/live/master_union/config', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

// 申请接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=113920494
export const applyTablent = createAsyncThunk(
  'TalentApply/applyTablent',
  async (p: any, store: any) => {
    const resp = await http.post('/live/master_union/apply', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 邀请详情 http://wiki.xunlei.cn/pages/viewpage.action?pageId=113920504
export const inviteInfo = createAsyncThunk(
  'TalentApply/inviteInfo',
  async (p: any, store: any) => {
    const resp = await http.post('/live/master_union/invite_detail', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 同意邀请、拒绝邀请 http://wiki.xunlei.cn/pages/viewpage.action?pageId=113920527
export const inviteUpdate = createAsyncThunk(
  'Tablent/inviteUpdate',
  async (p: any, store: any) => {
    const resp = await http.post('/live/master_union/update_invite_status', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// 【达人邀请-邀请前验证】  http://wiki.xunlei.cn/pages/viewpage.action?pageId=127597791
export const act_invite_detail = createAsyncThunk(
  'TalentApply/live/master_union/act_invite_detail',
  async (arg: any, store: any) => {
    const resp = await http.post('/live/master_union/act_invite_detail', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

export enum ApplyStatus {
  可申请 = 0,
  审核中 = 1,
}

const initialState: {
  status: ApplyStatus
  invite_info: {
    master_union?: any
    member?: any
    status?: InviteStatus
    /** 是否跳转到新版客户端邀请页面 */
    redirect_new_apply?: boolean
    is_streamer?: boolean
  }
  code?: string
  urls?: string[]
  scheme?: string // 不为空时 点击申请跳转
} = {
  status: ApplyStatus.审核中,
  invite_info: {
    status: InviteStatus.Check,
  },
}

export const TalentApplySystemSlice = createSlice({
  name: 'TalentApplySystem',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTablentApplyInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {...data, scheme: data.scheme || ''})
    })
    builder.addCase(inviteInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state.invite_info, data)
    })
  },
})

export const TalentApplyAction = TalentApplySystemSlice.actions
export default TalentApplySystemSlice.reducer
